import { DefaultNumberTransformer, NumberStyles } from '@ngneat/transloco-locale';
import { Currency, CurrencyCodePipe } from '../currency';

export class NumberTransformer extends DefaultNumberTransformer {
  override transform(value: number | string, type: NumberStyles, locale: string, options: Intl.NumberFormatOptions): string {
    // Fixed Yatta format for percentages
    if (type === 'percent') {
      return super.transform(value, 'percent', locale, { ...options, maximumFractionDigits: options.maximumFractionDigits ?? 2 }).replace(/\s+/g, '');
    }

    // Fixed Yatta format for currencies
    if (type === 'currency') {
      const localizedValue = super.transform(value, 'decimal', locale, options);
      const currencyDisplay = (options as { currencyDisplay: 'code' | 'symbol' | 'narrowSymbol' | 'name' }).currencyDisplay;
      if (currencyDisplay === 'symbol' || currencyDisplay === 'narrowSymbol') {
        const currencySymbol = new CurrencyCodePipe().transform(options.currency as Currency, currencyDisplay === 'symbol' ? 'wide' : 'narrow');
        return locale.startsWith('de') ? localizedValue + ' ' + currencySymbol : currencySymbol + localizedValue;
      } else if (currencyDisplay === 'code') {
        return options.currency + ' ' + localizedValue;
      }
    }

    // Otherwise, use the default
    return super.transform(value, type, locale, options);
  }
}
